module.exports = __webpack_public_path__ + "07e8efb9c94d396b9cbd88ac0818cb8b.svg";